export { default } from "./boolean-icon";
